<template>
    <div>
        <div class="myHead">
            <el-breadcrumb style="margin-top:20px;margin-left:20px" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/processManager/evaluation'}">安全制度</el-breadcrumb-item>
                <el-breadcrumb-item>添加</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="width:60%;margin:0 auto">
            <el-form-item label="考核名称" prop="reviewName">
                <el-input v-model="ruleForm.reviewName" style="width:500px"></el-input>
            </el-form-item>
            <el-form-item label="考核类型" prop="jobs">
                <el-select style="width:500px" v-model="ruleForm.reviewTypeId" filterable allow-create default-first-option placeholder="考核类型">
                    <el-option
                            v-for="item in typeArr"
                            :key="item.id"
                            :label="item.reviewTypeName"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="考核状态" prop="jobs">
                <el-select style="width:500px" v-model="ruleForm.status" filterable allow-create default-first-option placeholder="考核状态">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-button type="primary" class="addBtn" @click="submitForm()">确定</el-button>
    </div>
</template>

<script>
    import Vue from "vue";

    export default {
        data() {
            return {
                typeArr:[],
                ruleForm: {
                    name: "",
                },
                rules: {
                    name: [{required: true, message: "请输入名称", trigger: "blur"}],
                },
                options: [
                    {
                        value: "0",
                        label: "申请中",
                    },
                    {
                        value: "1",
                        label: "考核中",
                    },
                    {
                        value: "2",
                        label: "考核通过",
                    },
                    {
                        value: "3",
                        label: "考核未通过",
                    },
                ],
                getObj: {},
            };
        },
        mounted:function(){
            this.getType();
        },
        methods: {
            getType(){
                this.componentsMoudel.httpRequest
                    .getRequestHander("/reviewType/list_all")
                    .openLoad()
                    .startGet()
                    .then((res) => {
                        this.typeArr = res.body.data;
                    });
            },

            submitForm() {
                this.componentsMoudel.httpRequest
                    .getRequestHander("/assessmentReview/save")
                    .openLoad()
                    .startPost(this.ruleForm)
                    .then((res) => {
                        if (res.result == "success") {
                            this.$message({
                                showClose: true,
                                message: "添加成功",
                                type: "success",
                            });
                            this.$router.push({
                                path: "/processManager/evaluation",
                            });
                        }
                    });
            },
        },
        created() {
            let obj = this.$route.params.key;
            if (this.$route.params.key) {
                this.getObj = obj;
                this.ruleForm = {
                    name: obj.name,
                    content: obj.content,
                    value: [obj.departmentVo.id, obj.jobId],
                };
            } else {
                this.ruleForm = {
                    name: "",
                };
            }
        },
    };
</script>

<style scoped>
    .addBtn {
        display: block;
        width: 300px;
        margin: 0 auto;
    }

    .myHead {
        position: absolute;
        top: 0px;
        left: 250px;
        width: 80%;
        height: 160px;
    }
</style>
